import * as AuthActions from './../store/actions/auth.actions';
import { Injectable } from '@angular/core';

//importaciones supertokens
import { sendPasswordResetEmail, signIn, signUp } from 'supertokens-web-js/recipe/emailpassword';
import Session from 'supertokens-web-js/recipe/session';
import {
    sendVerificationEmail,
    verifyEmail,
    EmailVerificationClaim,
} from 'supertokens-web-js/recipe/emailverification';
import {
    getAuthorisationURLWithQueryParamsAndSetState,
    signInAndUp,
} from 'supertokens-web-js/recipe/thirdparty';

//Uso esta liabreria ngx-cookie-service para manejar las cookies
import { CookieService } from 'ngx-cookie-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/app.reducer';

@Injectable({
    providedIn: 'root',
})
export class SupertokensService {
    private errorTranslations: { [key: string]: string } = {
        //correo invalido
        'Email is not valid': 'El email es inválido',

        // correo ya existe
        'This email already exists. Please sign in instead.':
            'Este correo electrónico ya existe. Por favor, inicia sesión en su lugar.',

        //caracteres contraseña
        'Password must contain at least 8 characters, including a number':
            'La contraseña debe contener al menos 8 caracteres, incluido un número',

        //incluir una letra contraseña
        'Password must contain at least one alphabet':
            'La contraseña debe contener al menos una letra',
    };


    constructor(
        private cookieService: CookieService,
        private http: HttpClient,

        private store: Store<AppState>
    ) {}

    get accesToken() {
        let token: any = this.cookieService.get('st-access-token') || null;
        return token;
    }

    // get userInformation() {
    //     console.log('user-data', this.cookieService.get('user-data'));
    //     let userData: any = this.cookieService.get('user-data') || null;
    //     return userData;
    // }

    signUpClicked(email: string, password: string): Promise<any> {
        //Documentación: https://supertokens.com/docs/emailpassword/custom-ui/email-password-login

        //Convierto el observable de la documentación en promesa para manejar mejor la respuesta en el componente
        return new Promise(async (resolve, reject) => {
            try {
                let response = await signUp({
                    formFields: [
                        {
                            id: 'email',
                            value: email,
                        },
                        {
                            id: 'password',
                            value: password,
                        },
                    ],
                });

                switch (response.status) {
                    case 'OK':
                        let userInfo = JSON.parse(
                            response.fetchResponse.headers.get('user-info')
                        );
                        let newResponse = { ...response, userInfo };

                        resolve(newResponse); // Resolve promise

                        break;

                    case 'FIELD_ERROR':
                        // one of the input formFields failed validation
                        response.formFields.forEach((formField) => {
                            //si está la traduccion la devuelve
                            if (formField.error in this.errorTranslations) {
                                formField.error =
                                    this.errorTranslations[formField.error];
                            }

                            reject(formField.error);
                        });

                        break;

                    case 'SIGN_UP_NOT_ALLOWED':
                        reject(response.reason); // Reject promise with error
                        break;

                    default:
                        break;
                }
            } catch (err: any) {
                if (err.isSuperTokensGeneralError === true) {
                    reject(err.message); // Reject promise with error
                } else {
                    const data = await err.json();
                    console.log('mensaje error ', data.response);
                    reject('Error general. ' + data.response); // Reject promise with error
                }
            }
        });
    }

    signInClicked(email: string, password: string): Promise<any> {
        //Documentación: https://supertokens.com/docs/emailpassword/custom-ui/email-password-login

        //Convierto el observable de la documentación en promesa para manejar mejor la respuesta en el componente
        return new Promise(async (resolve, reject) => {
            try {
                console.log('inside try');

                let response = await signIn({
                    formFields: [
                        {
                            id: 'email',
                            value: email,
                        },
                        {
                            id: 'password',
                            value: password,
                        },
                    ],
                });

                switch (response.status) {
                    case 'OK':
                        // ==>>> en este punto supertokens guarda los tokens en las cookies
                        let userInfo = JSON.parse(
                            response.fetchResponse.headers.get('user-info')
                        );
                        let userData = JSON.parse(
                            response.fetchResponse.headers.get('user-data')
                        );
                        let user = JSON.parse(
                            response.fetchResponse.headers.get('user')
                        );
                        // let accessToken = JSON.parse(
                        //     response.fetchResponse.headers.get('st-access-token')
                        // );
                        console.log('accessToken', response.fetchResponse.headers.get('st-access-token'));
                        let userToken = response.fetchResponse.headers.get('st-access-token');

                        let newResponse = { ...response, userInfo, userData, userToken, userData2: user };

                        console.log('newResponse',newResponse);

                        resolve(newResponse); // Resolve promise
                        break;

                    case 'FIELD_ERROR':
                        response.formFields.forEach((formField) => {
                            if (formField.id === 'email') {
                                // Email validation failed

                                reject(new Error('Error en campo email')); // Reject promise with error
                            }
                        });
                        break;

                    case 'WRONG_CREDENTIALS_ERROR':
                        reject(new Error('Email o contraseña incorrecto')); // Reject promise with error
                        break;
                    case 'SIGN_IN_NOT_ALLOWED':
                        reject(new Error(response.reason)); // Reject promise with error
                        break;
                    // case 'SESSION_REFRESH':
                    //     console.log('🔄 Sesión refrescada');
                    //     this.store.dispatch(
                    //         new AuthActions.SetAuthenticated({
                    //             token: this.accesToken,
                    //             usuarioAutenticado: true,
                    //             emailVerificado: true,
                    //             estaAutenticado: true,
                    //         })
                    //     );
                    //     break;

                    default:
                        break;
                }
            } catch (err: any) {
                console.log({err});
                if (err.isSuperTokensGeneralError === true) {
                    reject(new Error(err.message)); // Reject promise with error
                } else {
                    const data = await err.json();
                    console.log('mensaje error ', data.response);
                    reject(new Error('Error general. ' + data.response)); // Reject promise with error
                }
            }
        });
    }

    async emailVerificado(): Promise<boolean> {
        //Documentación: https://supertokens.com/docs/emailpassword/custom-ui/enable-email-veri

        if (await Session.doesSessionExist()) {
            let validationErrors = await Session.validateClaims();
            if (validationErrors.length === 0) {
                // user has verified their email address
                console.log('entra validar mail');
                return true;
            } else {
                for (const err of validationErrors) {
                    console.log('error validacion mail', validationErrors);
                    if (err.id === EmailVerificationClaim.id) {
                        // email is not verified
                    }
                }
            }
        }
        // a session does not exist, or email is not verified
        return false;
    }

    async sendEmail(): Promise<any> {
        //Documentación:
        //https://supertokens.com/docs/emailpassword/custom-ui/enable-email-verification
        return new Promise(async (resolve, reject) => {
            try {
                let response = await sendVerificationEmail();
                if (response.status === 'EMAIL_ALREADY_VERIFIED_ERROR') {
                    reject('EMAIL_ALREADY_VERIFIED_ERROR');
                } else {
                    resolve(response);
                }
            } catch (err: any) {
                if (err.isSuperTokensGeneralError === true) {
                    reject(err.message);
                } else {
                    const data = await err.json();
                    console.log('mensaje error ', data.response);
                    reject('Error general. ' + data.response); // Reject promise with error
                }
            }
        });
    }

    async consumeVerificationCode(): Promise<any> {
        //Documentación:
        //https://supertokens.com/docs/emailpassword/custom-ui/enable-email-verification
        return new Promise(async (resolve, reject) => {
            try {
                let response = await verifyEmail();
                if (
                    response.status === 'EMAIL_VERIFICATION_INVALID_TOKEN_ERROR'
                ) {
                    reject(
                        '¡Ups! Parece que el enlace de verificación expiró. Inténtalo de nuevo.'
                    );
                } else {
                    //en este punto guarda el token en cookies
                    resolve(response);
                }
            } catch (err: any) {
                if (err.isSuperTokensGeneralError === true) {
                    reject(err.message);
                } else {
                    const data = await err.json();
                    console.log('mensaje error ', data.response);
                    reject('Error general. ' + data.response); // Reject promise with error
                }
            }
        });
    }

    async googleSignInClicked(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                const authUrl =
                    await getAuthorisationURLWithQueryParamsAndSetState({
                        thirdPartyId: 'google',

                        // This is where Google should redirect the user back after login or error.
                        // This URL goes on the Google's dashboard as well.
                        frontendRedirectURI: 'http://localhost:8100/google',
                    });
                console.log(
                    'authUrl getAuthorisationURLWithQueryParamsAndSetState',
                    authUrl
                );
                resolve(authUrl);
                //window.location.assign(authUrl);
                // console.log('respuesta google signIn')
                /*
        Example value of authUrl: https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&access_type=offline&include_granted_scopes=true&response_type=code&client_id=1060725074195-kmeum4crr01uirfl2op9kd5acmi9jutn.apps.googleusercontent.com&state=5a489996a28cafc83ddff&redirect_uri=https%3A%2F%2Fsupertokens.io%2Fdev%2Foauth%2Fredirect-to-app&flowName=GeneralOAuthFlow
        */

                // we redirect the user to google for auth.
            } catch (err: any) {
                if (err.isSuperTokensGeneralError === true) {
                    // this may be a custom error message sent from the API by you.
                    reject(err.message);
                    //window.alert(err.message);
                } else {
                    const data = await err.json();
                    console.log('mensaje error ', data.response);
                    reject('Error general. ' + data.response); // Reject promise with error
                }
            }
        });
    }

    async handleGoogleCallback(): Promise<any> {
        console.log('antes signInAndUp()');

        return new Promise(async (resolve, reject) => {
            try {
                const response = await signInAndUp();

                if (response.status === 'OK') {
                    let userInfo = JSON.parse(
                        response.fetchResponse.headers.get('user-info')
                    );
                    let newResponse = { ...response, userInfo };

                    resolve(newResponse); // Resolve promise
                    // if (response.createdNewRecipeUser && response.user.loginMethods.length === 1) {
                    // // sign up successful
                    // console.log('sign up ok en signInAndUp()',response)
                    // resolve(response)
                    // } else {
                    // // sign in successful
                    // console.log('sign in ok en signInAndUp()',response)

                    // resolve(response)
                    // }
                    //window.location.assign("/home");
                } else if (response.status === 'SIGN_IN_UP_NOT_ALLOWED') {
                    // the reason string is a user friendly message
                    // about what went wrong. It can also contain a support code which users
                    // can tell you so you know why their sign in / up was not allowed.
                    reject(response.reason);
                } else {
                    // SuperTokens requires that the third party provider
                    // gives an email for the user. If that's not the case, sign up / in
                    // will fail.

                    // As a hack to solve this, you can override the backend functions to create a fake email for the user.

                    reject(
                        'No email provided by social login. Please use another form of login'
                    );
                    //window.location.assign("/auth"); // redirect back to login page
                }
            } catch (err: any) {
                if (err.isSuperTokensGeneralError === true) {
                    // this may be a custom error message sent from the API by you.
                    reject(err.message);
                } else {
                    const data = await err.json();
                    console.log('mensaje error ', data.response);
                    reject('Error general. ' + data.response); // Reject promise with error
                }
            }
        });
    }

    // Método para iniciar sesión o registrarse usando los tokens de Google (utlizado para mobile)
    signInWithGoogleTokens(oAuthTokens: {
        access_token: string;
        id_token: string;
    }): Promise<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8',
        });

        const body = {
            thirdPartyId: 'google',
            // clientType: 'mobile',  // O cualquier valor que corresponda a tu aplicación
            oAuthTokens: oAuthTokens,
        };

        const url = `${environment.url}/supertokens`;

        return new Promise<any | void>((resolve, reject) => {
            this.http
                .post(url, body, {
                    headers,
                    observe: 'response', //permite leer los headers de la response
                })
                .subscribe({
                    next(response: any) {
                        if (response.body.status === 'OK') {
                            console.log('User session obtained:', response);
                            // Acceder a los encabezados
                            const userInfoHeader =
                                response.headers.get('user-info');

                            if (userInfoHeader) {
                                console.log(
                                    'user-info header:',
                                    userInfoHeader
                                );

                                // Si es un string JSON, puedes parsearlo
                                let userInfo = JSON.parse(userInfoHeader);
                                console.log('Parsed user-info:', userInfo);

                                let newResponse = { ...response, userInfo };

                                resolve(newResponse); // Resolve promise
                            } else {
                                reject('Error al leer UserInfoHeader');
                            }
                        } else {
                            reject(
                                'Error en la autenticación de ST' +
                                    response.status
                            );
                        }
                    },
                    error(msg) {
                        reject(msg);
                    },
                });
        });
    }

    async resetPasswordClicked(email: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await sendPasswordResetEmail({
                    formFields: [{
                        id: "email",
                        value: email
                    }]
                });

                if (response.status === "FIELD_ERROR") {
                    reject(response);
                } else {
                    // Email enviado exitosamente
                    resolve(response);
                }
            } catch (err: any) {
                if (err.isSuperTokensGeneralError === true) {
                    reject(err.message);
                } else {
                    const data = await err.json();
                    console.log('mensaje error ', data.response);
                    reject('Error general. ' + data.response);
                }
            }
        });
    }                                          
}
